/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
import * as React from 'react';
import propTypes from 'prop-types';
import {
  Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TablePagination, TableRow,
} from '@mui/material';
import FullpageLoading from '@components/FullpageLoading';
import useConnectionContext from '@hooks/useConnectionContext';
import useSettings from '@/hooks/useSettings';

// import { PRODUCT_TYPE } from '@constants';
import { POLICY_COLUMNS } from './constants';
import { usePolicyList } from './hooks';
import Empty from '../Transactions/Empty';

/**
 * policy 列表
 * tab - 需要展示的 tab
 * index - 需要展示的 tab 对应的 index
 * tabIndex - 当前展示的 tab 的 index
 */
export const TabPanel = React.memo(({
  tab, tabIndex, index, searchValue,
}) => {
  const { store: { name, info } } = useConnectionContext();
  const { settingsInfo: { timeZone } = {} } = useSettings();
  const {
    isEmpty,
    isLoading,
    total,
    rows,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    handleClickPolicy,
  } = usePolicyList(tab, tabIndex, index, searchValue, name, info);
  // if (isEmpty) {
  // eslint-disable-next-line max-len
  //   return <Empty hidden={tabIndex !== index} primary="No covers" secondary="You don’t have any covers with Seel yet." />;
  // }
  return (
    <div hidden={tabIndex !== index} style={{ width: '100%' }}>
      {isLoading ? (<FullpageLoading mask />) : null}
      <Paper sx={{
        width: '100%',
        marginBottom: '40px',
        overflow: 'hidden',
        '&.MuiPaper-root': {
          boxShadow: 'none',
        },
      }}
      >
        <TableContainer sx={{ maxHeight: 1200, minWidth: 780 }}>
          <Table stickyHeader aria-label="cover table">
            <TableHead>
              <TableRow>
                {POLICY_COLUMNS?.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {
                rows.map((row, i) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={`${row.policyId}_${i}_${index}` || i}
                    onClick={() => handleClickPolicy(row.policyId, row.policyType, row.code)}
                    sx={{
                      '&': {
                        cursor: name === 'Shoplazza' ? 'inherit' : 'pointer',
                      },
                    }}
                  >
                    {POLICY_COLUMNS?.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={`${column.id}_${index}`} align={column.align}>
                          {column.format
                            ? column.format(value, name, timeZone, row)
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </TableContainer>
        {isEmpty && <Empty hidden={tabIndex !== index} primary="No covers" secondary="You don’t have any covers with Seel yet." />}
        {
          rows?.length > 0
          && (
            <TablePagination
              component="div"
              count={total}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                '& .MuiTablePagination-selectLabel': {
                  display: 'none',
                },
                '& .MuiInputBase-root': {
                  display: 'none',
                },
              }}
            />
          )
        }

      </Paper>
    </div>
  );
});

TabPanel.propType = {
  rows: propTypes.array.isRequired,
};
